export default __webpack_public_path__ + "5f764f2c5bddcc0b82dfade6cbfd6e86.png";